import { okOrThrow } from "../../../../response.js";
import { authHeader, postJson, acceptJson } from "../../../../shared.js";
async function pause(apiUrl, accessToken, customerId, subscriptionId, request) {
  return okOrThrow(
    await fetch(
      `${apiUrl}/customers/customer/${encodeURIComponent(
        customerId
      )}/subscription/${subscriptionId}/pause`,
      {
        method: "POST",
        headers: {
          ...acceptJson,
          ...postJson,
          ...authHeader(accessToken)
        },
        body: JSON.stringify(request)
      }
    )
  );
}
export {
  pause
};
//# sourceMappingURL=pause.js.map
